<template>
    <div class="rating">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            v-for="i in [1, 2, 3, 4, 5]"
            :key="i"
            :class="{ filled: i <= roundedValue }"
        >
            <path
                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
            ></path>
        </svg>
        <span class="rating-value">{{ value.toFixed(1) }}</span>
    </div>
</template>

<style lang="scss" scoped>
.rating {
    display: inline-flex;
    align-items: center;
    gap: 2px;

    svg {
        width: 16px;
        height: 16px;
        color: #f2f0f4;
        fill: #f2f0f4;

        &.filled {
            color: #facc15;
            fill: #facc15;
        }
    }

    .rating-value {
        font-size: 14px;
        line-height: 1;
        margin-left: 4px;
    }
}
</style>

<script>
export default {
    props: {
        value: {
            type: Number,
            required: true
        }
    },
    computed: {
        roundedValue() {
            return Math.floor(this.value);
        }
    }
};
</script>
